import { cn } from '@anytag/shared-utils';
import { Carousel } from '@anytag/shared-molecules';
import { PostModal } from '@anytag/shared-molecules';
import { SupportedSocialMediaType } from '@anytag/shared-types';

interface PostInfoSectionProps {
  caption: string;
  images?: string[];
  postUrl?: string | null;
  postedDate?: string | null;
  hasImageDownload?: boolean;
  socialMedia?: keyof typeof SupportedSocialMediaType;
  influencer: React.ComponentProps<typeof PostModal.InfluencerInfo>['info'];
}

export const PostInfoSection = ({
  images,
  caption,
  postUrl,
  influencer,
  postedDate,
  socialMedia,
  hasImageDownload
}: PostInfoSectionProps) => (
  <>
    <div className="flex justify-between">
      <PostModal.InfluencerInfo info={influencer} />

      {postUrl || postedDate ? (
        <div className="flex flex-none flex-col items-end justify-center gap-1">
          <PostModal.SocialLink socialMedia={socialMedia} postUrl={postUrl} />
          <PostModal.Date value={postedDate} />
        </div>
      ) : null}
    </div>
    {images?.length ? (
      <Carousel
        className={styles.carousel}
        sources={images}
        showIcon
        imageDownload={{
          allowed: !!hasImageDownload,
          filename: `${influencer.name}_post_images_on_${postedDate}`
        }}
      />
    ) : null}
    <div className={styles.caption}>{caption}</div>
  </>
);

const styles = {
  caption: cn('mt-4 box-border h-38 overflow-auto rounded-sm border-base-border p-2 text-base whitespace-pre-wrap'),
  carousel: cn('mt-6 w-full', '[&_.sliderImage]:h-105.5 [&_.sliderImage]:w-105.5')
};
